<template>
  <div class="client js_index_client"
    v-if="
      Object.is(clientData.ifCaseData, 'y') ||
        Object.is(clientData.ifCaseList, 'y')
    "
  >
    <p class="title">客户案例</p>
    <template v-if="Object.is(clientData.ifCaseData, 'y')">
      <div class="client-data">
        <p class="data-title">{{ clientData.titleName }}</p>
        <div class="data-group">
          <div
            class="data-item"
            v-for="(item, index) in clientData.numDescription"
            :key="index"
          >
            <p class="data">{{ item.promotionTitle }}</p>
            <p>{{ item.descriptionDetails }}</p>
          </div>
        </div>
      </div>
      <div class="client-img" v-if="clientData.casePictureUrl">
        <img
          :src="utils.setOssUrl(clientData.casePictureUrl)"
          alt="客户案例合作图"
        />
      </div>
    </template>
    <template v-if="Object.is(clientData.ifCaseList, 'y')">
      <ul class="client_box">
        <li class="client_one" :class="{client_two:index>0}" v-for="(item,index) in clientList"
            :key="item.moduleId">
          <a
            :href="getLink(item)"
            target="_blank"
            class="one_link vishide animate__animated"
            @click="handleStoryDetailClick"
          >
            <div class="one_img_box">
              <img class="one_img" :src="utils.setOssUrl(item.picture)" alt="">
            </div>
            <div class="one_bot">
              <p class="one_title">{{ item.title }}</p>
              <p class="one_desc">{{ item.digest }}</p>
              <p class="one_detail">
                <dj-button>了解详情</dj-button>
              </p>
            </div>
          </a>
        </li>
      </ul>
      <p class="more">
        <dj-button type="dark" href="/example/list">查看更多</dj-button>
      </p>
    </template>
  </div>
</template>

<script>
import $ from "jquery";
import module from "@/const/module";
import utils from "@/utils/utils"
import { getCaseList, getCustomerCaseData } from "@/api/product.js";

export default {
  name: "clientCase",
  props: {},
  data() {
    return {
      utils,
      modules: module.example,
      // 客户案例-数据配置
      clientData: {},
      // 客户案例-李彪
      clientList: [],
      page: {
        pageNo: 1,
        pageSize: 3,
        total: 0
      },
    };
  },
  created() {
    this.getCustomerCaseData();
    this.getCaseList();
  },
  mounted() {
    this.removeVishide();
    this.$nextTick(() => {
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll);
      window.onresize = () => {
        this.removeVishide();
      };
    });
  },
  methods: {
    /**
     * 获取客户案例-数据配置
     */
    getCustomerCaseData() {
      getCustomerCaseData().then((res) => {
        if (res.success) {
          this.clientData = res.data || {}
        }
      });
    },
    /**
     * 获取客户案例-列表
     */
    getCaseList() {
      const params = {
        configType: this.modules.moduleType,
        ...this.page
      };
      getCaseList(params).then((res) => {
        if (res.success) {
          this.clientList = res.data.caseList || [];
          this.page.total = res.data.count;
          this.$nextTick(() => {
            this.removeVishide();
          })
        }
      });
    },
    /**
     * 获取跳转链接
     * @param {Object} data 数据
     */
    getLink(data) {
      const jumpType = Object.is(data.jumpType, 'details_page')
      const res = jumpType
        ? `/example/details?id=${data.moduleId}&moduleType=${this.modules.moduleType}`
        : data.jumpUrl
      return res
    },
    /**
     * 点击事件
     */
    handleStoryDetailClick() {
      const params = {
        officialSite_e_title: document.title,
        officialSite_e_source: '首页-客户案例',
      };
      this.$sensors.officialSite_StoryDetail(params);
    },
    handleScroll() {
      utils.handleScroll($(".js_index_client .client_one"), (i, el) => {
        setTimeout(() => {
          el.children(".one_link").removeClass("vishide").addClass("animate__slideInUp").removeClass("animate__slideOutDown");
        }, i * 100);
      }, (i, el) => {
        setTimeout(() => {
          el.children(".one_link").removeClass("animate__slideInUp").addClass("animate__slideOutDown");
        }, i * 100);
      });
    },
    removeVishide() {
      let w = $(window).width();
      if (w < 960) {
        $(".js_index_client .one_link").removeClass("vishide");
        $(".js_index_client .one_link").removeClass("animate__animated");
      } else {
        $(".js_index_client .one_link").addClass("vishide");
        $(".js_index_client .one_link").addClass("animate__animated");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.client {
  .title {
    font-size: 40px;
    color: #333333;
    line-height: 56px;
    margin-top: 60px;
    text-align: center;
    font-weight: bold;
  }
  .client-data {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    padding: 70px 0 30px;
    .data-title {
      font-size: 36px;
      word-break: break-all;
      padding: 0 60px;
    }
    .data-group {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      font-size: 20px;
      color: #7f7f7f;
      margin-top: 60px;
      .data-item {
        flex: 1;
        text-align: center;
        margin-left: 30px;
        p {
          font-size: 28px;
        }
        &:first-child {
          margin-left: 0;
        }
        .data {
          font-weight: 500;
          font-size: 50px;
          color: #333;
          margin-bottom: 25px;
        }
      }
    }
  }
  .client-img {
    position: relative;
    width: 100%;
    height: 424px;
    overflow: hidden;
    margin-top: 30px;
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 40%;
      height: 100%;
      // filter: blur(20px);
      pointer-events: none;
    }
    &::before {
      background: linear-gradient(to right, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
      left: 0;
    }
    &::after {
      background: linear-gradient(to left, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0) 100%);
      right: 0;
    }
    img {
      display: block;
      max-width: 100%;
      width: 100%;
      height: 100%;
    }
  }
  .client_box {
    display: flex;
    justify-content: center;
    padding: 60px;
    .client_one {
      width: 100%;
      .one_link {
        background-color: #FFFFFF;
        display: inline-block;
        width: 100%;
        height: 100%;
        .one_img {
          width: 100%;
          height: 354px;
        }
        .one_title {
          font-size: 26px;
          color: #333333;
          line-height: 37px;
          padding: 32px 32px 16px 32px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .one_desc {
          font-size: 23px;
          color: #666666;
          line-height: 32px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          padding: 0 32px;
        }
        .one_detail {
          display: flex;
          justify-content: center;
          margin: 24px 0 34px;
        }
      }
    }
    .client_two {
      display: none;
    }
  }
  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 60px;
  }
}
@media (min-width: 750px) and (max-width: 960px) {
  .client {
    .title {
      font-size: 32px;
      line-height: 45px;
      margin-top: 60px;
    }
    .client_box {
      display: flex;
      justify-content: center;
      padding: 40px 60px;
      .client_one {
        width: 100%;
        .one_link {
          background-color: #FFFFFF;
          display: flex;
          width: 100%;
          height: 100%;
          .one_img {
            width: 336px;
            height: 188px;
          }
          .one_bot {
          }
          .one_title {
            font-size: 18px;
            color: #333333;
            line-height: 25px;
            padding: 24px 24px 8px 24px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .one_desc {
            font-size: 16px;
            color: #666666;
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            padding: 0 24px;
            height: 66px;
          }
          .one_detail {
            display: flex;
            justify-content: flex-start;
            margin: 12px 0 0 24px;
          }
        }
      }
      .client_two {
        display: none;
      }
    }
    .more {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 60px;
    }
  }
}
@media (min-width: 961px) {
  .client {
    .title {
      font-size: 32px;
      line-height: 42px;
      margin-top: 62px;
    }
    .client-data {
      padding: 70px 60px 40px;
      .data-group {
        .data-item {
          margin: 0 60px;
          p {
            font-size: 20px;
          }
          &:first-child {
            margin-left: 60px;
          }
          .data {
            margin-bottom: 16px;
            font-size: 60px;
          }
        }
      }
    }
    .client_box {
      display: flex;
      justify-content: center;
      padding: 60px 0;
      .client_one {
        width: 384px;
        margin-left: 24px;
        &:first-child {
          margin-left: 0;
        }
        .one_link {
          background-color: #FFFFFF;
          display: inline-block;
          width: 100%;
          height: 100%;
          .one_img_box{
            overflow: hidden;
          }
          &:hover {
            box-shadow: 0px 15px 30px 0px rgba(0, 0, 0, 0.07);
            .one_img {
              transform: scale(1.1);
            }
            .one_bot {
              .one_title {
                color: #0064EB;
              }
            }
          }
          .one_img {
            width: 100%;
            height: 216px;
            transition: transform .5s;
          }
          .one_title {
            font-size: 18px;
            line-height: 25px;
            padding: 24px 24px 12px 24px;
          }
          .one_desc {
            height: 66px;
            font-size: 16px;
            color: #666666;
            line-height: 22px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            padding: 0 24px;
          }
          .one_detail {
            display: flex;
            justify-content: center;
            margin: 24px 0;
          }
        }
      }
      .client_two {
        display: block;
      }
    }
    .more {
      margin-bottom: 60px;
    }
  }
}
</style>
